import { HsaAdyenOnboardingStatus } from "@redotech/crdb-enums/conversion/hsa-adyen-onboarding-status";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/** The Verify your business page's state. Not found unless Redo created the team's Adyen account. */
export const getHsaAdyenKycState = {
  name: "getHsaAdyenKycState" as const,
  input: z.null(),
  output: z.object({
    status: createEnum(HsaAdyenOnboardingStatus),
    started: z.boolean(),
    problems: z.array(z.object({ code: z.string(), message: z.string() })),
  }),
};
